import React from 'react';
export function AgitationSection() {
  return <section className="bg-brand-dark py-12 px-5" data-id="element-12">
      <div className="max-w-[750px] mx-auto text-center" data-id="element-13">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 leading-[1.2]" data-id="element-14">
          La verdad que nadie quiere decirte
        </h2>

        <p className="text-lg text-[#ccc] leading-[1.8] mb-5" data-id="element-15">
          Las ciudades modernas funcionan bajo un sistema de "Justo a Tiempo".
          Los supermercados{' '}
          <strong className="text-brand-orange font-semibold" data-id="element-16">
            solo tienen comida para 72 horas
          </strong>
          . Las bombas de agua dependen de electricidad. La policía tiene
          <strong className="text-brand-orange font-semibold" data-id="element-17">
            {' '}
            1 oficial por cada 1.000 ciudadanos
          </strong>
          .
        </p>

        <p className="text-lg text-[#ccc] leading-[1.8] mb-5" data-id="element-18">
          Si el suministro eléctrico cae por un ciberataque, una tormenta o
          simplemente una crisis de infraestructura,{' '}
          <strong className="text-white font-semibold" data-id="element-19">
            la sociedad urbana retrocede 200 años en menos de un día.
          </strong>
        </p>

        <p className="text-xl text-brand-orange font-bold leading-[1.7] mt-4" data-id="element-20">
          La pregunta no es SI va a pasar. La pregunta es si vas a estar
          preparado cuando pase.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10" data-id="element-21">
          <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/e1hWunX8G3epMouYhRy34o/41a044312d4e5adf11496f7d8d2f78c9.jpg.jpg" alt="Despensa de supervivencia con provisiones y herramientas" className="w-full h-64 object-cover" data-id="element-23" />
          </div>
          <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/11RGX8pj4fseXyzazmHSMW/76ff53d9663d4712a6b3aff0d67ace71.jpg.jpg" alt="Familia preparada durante un apagón" className="w-full h-64 object-cover" data-id="element-25" />
          </div>
          <div className="rounded-xl overflow-hidden border border-white/10 shadow-lg" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/8E8ad4ESy1AvYbwFn9jowr/e1df4e03999e217be10794a7d4d054ac.jpg.jpg" alt="Kit de suministros de emergencia organizado" className="w-full h-64 object-cover" data-id="element-27" />
          </div>
        </div>
      </div>
    </section>;
}